var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftboxGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.1 508.1",
    style: {
      enableBackground: "new 0 0 508.1 508.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M33.8,216.251v270.6c0,11.7,9.5,21.2,21.2,21.2h398.1c11.7,0,21.2-9.5,21.2-21.2v-270.6H33.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M377.9,14.551c-19-18.7-49.1-19.4-67.2-1.6c-12.6,12.3-44.7,58.5-56.7,91.8 c-12-33.3-44.1-79.5-56.7-91.8c-18.1-17.8-48.2-17.1-67.2,1.6s-19.8,48.3-1.7,66.1c17.9,17.5,104.9,73.6,125.6,57.2 c20.7,16.4,107.7-39.7,125.6-57.2C397.7,62.851,396.9,33.251,377.9,14.551z M151.9,57.551c-5.1-5-4.4-14,1.7-19.9 c4.4-4.3,9.2-5,11.7-5c2.4,0,5.8,0.6,8.6,3.3c9.9,9.8,29,38.5,40.9,61.8C191.2,86.051,161.9,67.351,151.9,57.551z M356.1,57.551 c-9.9,9.8-39.2,28.5-62.9,40.2c12-23.2,31-52,40.9-61.8c2.8-2.7,6.2-3.3,8.6-3.3c2.5,0,7.3,0.6,11.7,5 C360.4,43.551,361.2,52.551,356.1,57.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8B64C"
    },
    d: "M486.8,118.351H21.2c-11.7,0-21.2,9.5-21.2,21.2v55.4c0,11.7,9.5,21.2,21.2,21.2h465.7 c11.7,0,21.2-9.5,21.2-21.2v-55.4C508,127.851,498.5,118.351,486.8,118.351z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.7,
    y: 118.351,
    style: {
      fill: "#FF7058"
    },
    width: 102.7,
    height: 389.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.8,
    y: 216.251,
    style: {
      opacity: 0.2,
      fill: "#C47920",
      enableBackground: "new"
    },
    width: 440.4,
    height: 14.1
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftboxGift);
export default __webpack_public_path__ + "static/media/giftbox-gift.9a6c9ea4e3d418a2fa7967c302d91ce8.svg";
export { ForwardRef as ReactComponent };